import IntroductionWithImage from "../../../components/IntroductionWithImage";
import MainImageCarousel from "../../../components/MainImageCarousel";
import StickyNavAndFooter from "../../layout/StickyNavAndFooter";
import { yogaMainBlog, bhakthiYogaPageIntroduction } from "../../../data/data";
import { Box, Button } from "@chakra-ui/react";
import bhakthiYogaSymbolImg from '../../../resources/images/bhakthiYoga.jpg'
import { primaryColor, secondaryColorTwo } from "../../../config";
import { CarouselCardDetails_t } from "../../../components/Carousels/CarouselCard";


export default function BhakthiYoga() {
    const yogaMainBlogForYogaPage: CarouselCardDetails_t = yogaMainBlog
    delete yogaMainBlogForYogaPage.previous;
    delete yogaMainBlogForYogaPage.next;

    return (
        <StickyNavAndFooter>
            <MainImageCarousel />
            <IntroductionWithImage img={bhakthiYogaSymbolImg}>
                        {bhakthiYogaPageIntroduction}
                        <br />
                        <Box textAlign={"right"}>
                            <Button bg={primaryColor} color={"white"}
                            as={'a'}
                            href={"https://isha.sadhguru.org/yoga/yoga-articles-yoga/bhakti-yoga/"}
                            target="_blank"
                                _hover={{
                                    backgroundColor: secondaryColorTwo,
                                }}>Read</Button>
                        </Box>
                    </IntroductionWithImage>
        </StickyNavAndFooter>
    )
}